/* Contains the default layouts structure for each page */

import { v4 as uuidv4 } from "uuid"

const getPageDefaultLayout = (page_slug) => {
  let layout = null
  let slug = null
  let name = null

  layout = [
    {
      h: 40,
      w: 72,
      x: 0,
      y: 0,
      id: uuidv4(),
      maxH: 72,
      minH: 24,
      minW: 24,
      name: window.$t("Customer Journeys"),
      moved: false,
      props: {
        hidden: false,
        component_type: "customer_journeys",
        component_props: {
          label: window.$t("Customer Journeys")
        }
      },
      visible: true,
      preserveAspectRatio: false
    }
  ]

  slug = page_slug
  name = window.$t("Customer Journeys")

  return [layout, name, slug]
}

export default getPageDefaultLayout
